import { render, staticRenderFns } from "./SceneExample.vue?vue&type=template&id=65610833&scoped=true&"
import script from "./SceneExample.vue?vue&type=script&lang=js&"
export * from "./SceneExample.vue?vue&type=script&lang=js&"
import style0 from "./SceneExample.vue?vue&type=style&index=0&id=65610833&prod&scoped=true&lang=css&"
import style1 from "./SceneExample.vue?vue&type=style&index=1&id=65610833&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65610833",
  null
  
)

export default component.exports